const globalConstants = {
    defaultSpacing: 10,
    colors: {
        primary: '#1637A0',
        primary_light: '#9BB4DD',
        primary_disabled: '#C5D3EB',
        secondary: '#012059',
        secondary_dark: '#323334',
        light_grey: '#9B9B9B',
        bg_alternative: '#F2F3F4',
        bg_third: '#F2F3F4',
        third: '#406DBB',
        bg_status_inProgress: '#1149AA',
        bg_status_disabled: '#8E8E8E',
        bg_status_authorized: '#012059',
        available: '#00DA09',
        black: '#222222',
        white: '#FFFFFF',
        primary_text: '#222222',
        secondary_text: '#656565',
    },
    fontFamilies: {
        primary: ['Avenir-Roman', 'Helvetica', 'sans-serif'].join(','),
        primary_bold: ['Avenir-Black', 'Arial-Bold', 'sans-serif'].join(','),
        heavy: [
            'Boris-Black-Bloxx',
            'Avenir-Black',
            'Arial-Bold',
            'sans-serif',
        ].join(','),
    },
    fontSizes: {
        xxs: 10,
        xs: 12,
        sm: 14,
        md: 16,
        lg: 20,
        xl: 24,
        xl_lg: 28,
        xxl: 38,
    },
    screens: {
        xs: 0,
        sm: 768,
        md: 960,
        lg: 1280,
        xl: 1920,
    },
};
export default globalConstants;
//# sourceMappingURL=global-constants.js.map